import React from 'react';
import MainNavigation from '../../components/ui/MainNavigation';
import HeroSection from './components/HeroSection';
import SubsidyOverviewSection from './components/SubsidyOverviewSection';
import RegionalSubsidiesSection from './components/RegionalSubsidiesSection';
import ApplicationProcessSection from './components/ApplicationProcessSection';
import RegulationsTimelineSection from './components/RegulationsTimelineSection';
import FooterSection from '../homepage/components/FooterSection';

const SubsidiesAndRegulationsHub = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Navigation */}
      <MainNavigation />

      {/* Main Content with proper spacing for fixed navigation */}
      <main className="pt-16 lg:pt-0 lg:ml-[72px] transition-all duration-300">
        {/* Hero Section */}
        <HeroSection />

        {/* Subsidy Overview */}
        <SubsidyOverviewSection />

        {/* Regional Subsidies */}
        <RegionalSubsidiesSection />

        {/* Application Process */}
        <ApplicationProcessSection />

        {/* Regulations Timeline */}
        <RegulationsTimelineSection />
      </main>

      {/* Footer */}
      <FooterSection />
    </div>
  );
};

export default SubsidiesAndRegulationsHub;